
import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { IEstabelecimento } from "../../../../../../types/api/financeiro/operadoras-cartao";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCallback, useMemo, useState } from "react";
import DialogCrudEstabelecimento from "./DialogCrudEstabelecimento";

export default function SelecaoEstabelecimentos({ estabelecimentos, onSubmit, onDelete }: SelecaoEstabelecimentosProps) {

    const modalDefaultValue = useMemo(() => ({
        modalState: false,
        data: null
    }), [])

    const [openModal, setOpenModal] = useState<TOpenModalEstabelecimento>(modalDefaultValue)

    const handleOpenModal = useCallback((action: "create" | "close" | "edit", value?: TOpenModalEstabelecimento) => {
        if (action === "edit" && value) setOpenModal(value)
        if (action === "close") setOpenModal(modalDefaultValue)
        if (action === "create") setOpenModal({ ...modalDefaultValue, modalState: true })
    }, [modalDefaultValue])

    return (
        <>
            {
                estabelecimentos.length <= 0 &&
                <>
                    <Typography variant="h6">Vincular Estabelecimentos</Typography>
                    <Box
                        mt={1}
                        width="100%"
                        height={200}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                        border="1px solid #005540"
                        borderRadius={1}
                    >
                        <Typography fontWeight="bold" mb={1}>Nenhum estabelecimento vinculado à operadora de cartão</Typography>
                        <Button
                            startIcon={<AddIcon />}
                            variant="contained"
                            onClick={() => handleOpenModal("create")}
                        >
                            Adicionar
                        </Button>
                    </Box>
                </>
            }
            {
                estabelecimentos.length > 0 &&
                <>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h6">Estabelecimentos Vinculados</Typography>
                        <Button
                            variant="outlined"
                            startIcon={<AddIcon />}
                            onClick={() => handleOpenModal("create")}
                        >
                            Adicionar
                        </Button>
                    </Box>

                    <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>N° Estabelecimento</b></TableCell>
                                    <TableCell><b>Loja</b></TableCell>
                                    <TableCell align="right" />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    estabelecimentos.map((item, index) => {

                                        const editProp = {
                                            modalState: true,
                                            data: {
                                                ...item,
                                                index: index
                                            }
                                        }

                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    {item.numero_estabelecimento}
                                                </TableCell>

                                                <TableCell>
                                                    {item.loja.id} - {item.loja.nome}
                                                </TableCell>

                                                <TableCell align="right">
                                                    <IconButton
                                                        aria-label="edit"
                                                        onClick={() => handleOpenModal("edit", editProp)}
                                                    >
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton
                                                        aria-label="delete"
                                                        onClick={() => onDelete(editProp.data)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            }
            {
                openModal.modalState &&
                <DialogCrudEstabelecimento
                    {...{ onSubmit }}
                    values={openModal.data}
                    valueIndex={openModal.data?.index}
                    lastId={estabelecimentos[estabelecimentos.length - 1]?.id ?? 0}
                    open={openModal.modalState}
                    handleClose={() => handleOpenModal("close")}
                />
            }
        </>
    )
}

interface SelecaoEstabelecimentosProps {
    estabelecimentos: IEstabelecimento[];
    onSubmit: (valor: IEstabelecimento) => void;
    onDelete: (valor: IEstabelecimento) => void;
}

export type TOpenModalEstabelecimento = {
    modalState: boolean,
    data: TOpenModalEstabelecimentoData
}

export type TOpenModalEstabelecimentoData = IEstabelecimento & { index: number } | null
